import Skeleton from "@mui/material/Skeleton";
import { Box, DataGrid, DataGridCardProps, GalleryPlaceholder, Text } from "designSystem/index";
import { STANDARD_BORDER_STYLE } from "designSystem/styles/style-functions";
import ArrayDataStore from "csi/datastore/ArrayDataStore";
import React from "react";

interface CardItem {
	height: number;
	name: string;
}

const Card = (props: DataGridCardProps<CardItem>) => {
	const { item: { height, name } } = props;

	return (
		<Box
			bgcolor="background.paper"
			border={STANDARD_BORDER_STYLE}
			height={1}
			p={2}
		>
			<Box height={height}>
				<Text text={name} variant="subtitle1" />
			</Box>
		</Box>
	);
};

const SkeletonCard = () => {
	return (
		<Box
			bgcolor="background.paper"
			border={STANDARD_BORDER_STYLE}
			height={1}
			p={2}
		>
			<Skeleton height={100} variant="rectangular" />
		</Box>
	);
};

const PlaceholderComponent = () => {
	return (
		<GalleryPlaceholder titleProps={{ text: "No Data" }} />
	);
};

const data: CardItem[] = [];

for (let i = 0; i < 200; ++i) {
	data.push({
		height: 20 + Math.trunc(100 * Math.random()),
		name: `Card ${i}`,
	});
}

const store = new ArrayDataStore<CardItem>(data, "name");

export default () => {
	return (
		<DataGrid
			CardComponent={Card}
			PlaceholderComponent={PlaceholderComponent}
			SkeletonComponent={SkeletonCard}
			columns={1}
			design="list"
			spacing={2}
			store={store}
		/>
	);
};